import _ from 'lodash'
import moment from 'moment'
import GET_EVENTS from '../query'
import { requestPersistently } from '../../../utils/request'
import {
  getOutlookEventDeltaToken,
  updateOutlookEventDeltaToken,
} from '../../../../../server/store'

const DATA_LIMIT_PER_REQUEST = 100

// The calendar window is local wall time with a Z appended. Graph reads that Z as UTC,
// which shifts the fetched day by the local offset (11 hours in Sydney).
const localWallStampedAsUtcToRealUtc = value => {
  if (typeof value !== 'string' || value === '') return value
  const wallClock = value.replace(/Z$/i, '')
  const parsed = moment(wallClock)
  if (!parsed.isValid()) return value
  return parsed.toISOString()
}

export const requestEvents = async ({ client, params }) => {
  const { from, to, isDelta, reSyncDelta, selectedDelegateId } = params

  let nextDeltaLink = null
  let toReturn = []
  do {
    const requestDeltaToken = getOutlookEventDeltaToken()
    const startDateTime = localWallStampedAsUtcToRealUtc(from)
    const endDateTime = localWallStampedAsUtcToRealUtc(to)

    const requestProps = {
      client,
      type: 'query',
      options: {
        query: GET_EVENTS,
        variables: {
          startDateTime,
          endDateTime,
          top: isDelta ? undefined : DATA_LIMIT_PER_REQUEST,
          isCancelled: false,
          isDelta: isDelta || reSyncDelta,
          nextDeltaLink: nextDeltaLink != null ? nextDeltaLink : undefined,
          deltaToken:
            isDelta && !reSyncDelta && requestDeltaToken !== '' ? requestDeltaToken : undefined,
          selectedDelegateId,
        },
      },
    }
    const response = await requestPersistently({ requestProps })

    const deltaToken = _.get(response, 'data.getEvents.deltaToken')
    if (deltaToken && typeof deltaToken === 'string') updateOutlookEventDeltaToken(deltaToken)

    const toAdd = _.get(response, 'data.getEvents.deltaEvents', [])
    toReturn = [...toReturn, ...toAdd]

    const currentLink = nextDeltaLink
    nextDeltaLink = _.get(response, 'data.getEvents.nextDeltaLink', null)
    if (nextDeltaLink === currentLink) {
      nextDeltaLink = null
    }
  } while (nextDeltaLink != null)
  return toReturn
}
